<template>
<div id="pay-transfer" class="opt-content-wrapper pay-pane px-4 active">
    <!-- p class="mt-2">Choose your bank to start the payment</p-->
    <div class="modal-body">
        <p class="mt-3" v-html="data.message"></p>
        <div class="row m-0">
            <div class="col-12 px-0">
                <p class="mt-2 text-center text-tiny">Once your transfer is successful, please click the button below</p>
                <div class="form-group mb-2">
                    <button type="submit" class="btn app-bg-color" :style="{ background : appColor }" ref="btnActionPay" @click.prevent="confirm">Done. Confirm Payment</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'transfer',
    props: ['data', 'appColor'],
    data(){
        return {
            view: '',
            type: '',
        }
    },
    methods: {
        confirm() {
            var res = JSON.parse(window.raw) //JSON.parse(localStorage.raw);
            if (res.data.client_info)
                delete res.data.client_info;

            if (res.data.paymentoptions)
                delete res.data.paymentoptions;

            this.$parent.continueToMerchant({
                status: res.status,
                message: this.data.message,
            });
        },
    }
}
</script>
